import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import snakecaseKeys from 'snakecase-keys';
import ShiftAssignmentsForm from './ShiftAssignmentsForm';
import { sendAlert } from '../../actions/utils';
import { createMassiveShiftAssignmentsRequest } from '../../requests/shiftAssignment';

const basicShiftAssignment = () => ({
  assignedShiftId: '',
  changeInCard: false,
  contractIds: [],
  contracts: [],
  createdFrom: 'shift_assignment',
  createdById: '',
  currentShiftId: '',
  date: '',
  observation: '',
  shiftEnd: '',
  shiftStart: ''
});

const ShiftAssignmentsBossNew = ({ onSuccess, currentEmployee }) => {
  const [shiftAssignment, setShiftAssignment] = useState(basicShiftAssignment);
  const [isDisabled, setIsDisabled] = useState(false);
  const dispatch = useDispatch();

  const validateLength = shiftAssignmentValues => {
    if (!shiftAssignmentValues.contractIds.length) {
      dispatch(sendAlert({ kind: 'error', message: 'Debes seleccionar al menos un trabajador' }));
      setIsDisabled(false);
      return true;
    }
    return false;
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
  };

  const handleSuccessCreate = () => {
    const message = 'Turnos asignados con éxito';
    dispatch(sendAlert({ kind: 'success', message }));
    if (onSuccess) onSuccess(); // <-- cerrar formulario y mostrar datatable
  };

  const handleCreate = shiftAssignmentValues => {
    if (validateLength(shiftAssignmentValues.shiftAssignment)) {
      return;
    }
    const params = snakecaseKeys(shiftAssignmentValues);
    setIsDisabled(true);
    createMassiveShiftAssignmentsRequest({
      dispatch,
      params,
      formData: true,
      successCallback: handleSuccessCreate,
      failureCallback: error => {
        handleFailureRequest(error);
      }
    });
  };

  useEffect(() => {
    setShiftAssignment(basicShiftAssignment);
  }, [setShiftAssignment]);

  return (
    <>
      <ShiftAssignmentsForm
        shiftAssignment={shiftAssignment}
        formRequest={handleCreate}
        currentEmployee={currentEmployee}
        rrhh={false}
        isDisabled={isDisabled}
      />
    </>
  );
};
export default ShiftAssignmentsBossNew;
